import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { VendorProfile } from './VendorProfile'
import { getAccountProfile } from '../../features/friendSlice'
import { UserProfile } from './UserProfile'
import { PlannerProfile } from './PlannerProfile'

export const ProfilePage = () => {
	const { userId } = useParams()
	const dispatch = useDispatch()

    const curUserId = useSelector((s) => s.auth?.user?._id)
    const isSameUser = userId === curUserId

	const accountProfile = isSameUser ?
    useSelector(
		(s) => s.auth.user
	) :
    useSelector(
		(s) => s.friend.singleAccountProfile
	)

	useEffect(() => {
		dispatch(getAccountProfile(userId))
	}, [dispatch, userId])

	const renderProfile = () => {
		switch (accountProfile?.__t) {
			case 'user':
				return <UserProfile data={accountProfile} />
			case 'vendor':
			case 'kazoo-planner':
				return <VendorProfile data={accountProfile} />
			/**
			 * TODO:: Planner Tasks update according to API response
			 * TEMP to view UI
			 */
			// return <PlannerProfile data={accountProfile} />
			case 'vendor-staff':
			case 'planner-staff':
				return <UserProfile data={accountProfile} />
			default:
				return <h1>Loading</h1>
		}
	}
    
	return <div>{renderProfile()}</div>
}
